import { getLocale } from "../runtime";

const sv_writtenby = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Skrivet av`
};

const writtenby = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_writtenby(inputs)
	return "writtenBy";
};

export { writtenby as "writtenBy" };